<app-reporting [reportUrl]="reportUrl" [exportToPdf]="exportToPdf == '1' ? true : false" name="SampleReport" #SampleReport></app-reporting>